module.exports = __webpack_public_path__ + "static/media/f8.0055e3f2.png";